import React, { useEffect, useState } from "react";
import SelectARecordToView from "components/Records/SelectARecordToView";
import {
  Box,
} from "@mui/material";

import PeopleMovementTab from "components/Flow/Tabs/PeopleMovementTab";

import BasePaper from "components/Base/BasePaper";

import { getNodePeople, moveItemsBetweenNodes, communityNodeAPI } from "api/Community/CommunityAPI";


interface CommunityBottomDrawerProps {
  selectedNode: any | null;
  onUpdateNode: (updatedNode: any) => void;
  savingNode: boolean;
}


const CommunityBottomDrawer: React.FC<CommunityBottomDrawerProps> = ({
  selectedNode,
  onUpdateNode,
  savingNode,
}) => {
  const [nodeData, setNodeData] = useState<any | null>(null);

  useEffect(() => {
    setNodeData(selectedNode ? { ...selectedNode } : null);
    // setValue(0); // reset to first tab when switching nodes
  }, [selectedNode]);


  if (!selectedNode) {
    return <SelectARecordToView itemName="node" message="Select a node to view details" maxHeight={150} />;
  }

  return (
      <BasePaper>
        <Box sx={{ width: "100%" }}>
          <PeopleMovementTab
            nodeData={nodeData}
            nodeAPI={communityNodeAPI}
            getNodePeople={getNodePeople}
            movePeopleBetweenNodes={moveItemsBetweenNodes}
            includeMovementControls={false}
          />
        </Box>
      </BasePaper>
  );
};

export default CommunityBottomDrawer;
